import { ReactNode } from "react";
import { useState } from "react";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
interface CollapsePropsType {
  title?: any;
  children: ReactNode;
  expand?: boolean;
  showExpander?: boolean;
  extraCSS?: string;
}

const Collapse = (props: CollapsePropsType) => {
  const { title, children, expand, showExpander = true, extraCSS = "p-2" } = props;
  const [showContent, setShowContent] = useState(expand ? expand : false);

  const renderExpander = () => {
    if (!showExpander) {
      return null;
    }
    return showContent ? (
      <ChevronDownIcon className={"w-4"} />
    ) : (
      <ChevronRightIcon className={"w-4"} />
    );
  };

  return (
    <div className={`w-full ${extraCSS} relative`}>
      <div
        onClick={() => setShowContent(!showContent)}
        className={"w-full flex cursor-pointer space-x-2"}
      >
        {renderExpander()}
        {title && <div className={"font-bold"}>{title}</div>}
      </div>
      {showContent && <div className={"w-full"}>{children}</div>}
    </div>
  );
};

export default Collapse;
